import { Drawer } from "antd";
import React from "react";

export default function SideDrawerWrapper({
  children,
  openDrawer,
  handleCloseDrawer,
}: {
  children: React.ReactNode;
  openDrawer: boolean;
  handleCloseDrawer: () => void;
}) {
  return (
    <Drawer
      placement="right"
      closable={false}
      onClose={handleCloseDrawer}
      open={openDrawer}
      width={468}
      destroyOnClose
      styles={{
        body: {
          padding: 0,
        },
      }}
    >
      {children}
    </Drawer>
  );
}
